import React, { useCallback, useMemo, useState } from 'react'
import { getConsent, setConsent } from '../../utils/ga'
import './CookieConsent.scss'

export const CookieConsent: React.FC = () => {
  const initial = useMemo(() => getConsent(), [])
  const [visible, setVisible] = useState(initial === 'unknown')

  const accept = useCallback(() => {
    setConsent('granted')
    setVisible(false)
  }, [])

  const decline = useCallback(() => {
    setConsent('denied')
    setVisible(false)
  }, [])

  if (!visible) return null

  return (
    <div className="cookieConsent" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookieConsent__text">
        Käytämme anonyymiä analytiikkaa (GA4), jotta Aamukasaaja ei hajoa eikä kehity väärään
        suuntaan. Ei henkilötietoja, ei mainoksia, ei kytkykauppaa. Kaikkien evästeiden käsittely on
        särmää ja asianmukaista.
      </div>
      <div className="cookieConsent__actions">
        <button
          type="button"
          className="cookieConsent__button cookieConsent__button--decline"
          onClick={decline}
        >
          Hylkää
        </button>
        <button
          type="button"
          className="cookieConsent__button cookieConsent__button--accept"
          onClick={accept}
        >
          Hyväksy
        </button>
      </div>
    </div>
  )
}
